import { render } from "./MaterialsStationsVideoconferences.vue?vue&type=template&id=02565a67"
import script from "./MaterialsStationsVideoconferences.vue?vue&type=script&lang=js"
export * from "./MaterialsStationsVideoconferences.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__